import { createSlice } from '@reduxjs/toolkit';
import { Battery4chart } from 'src/models';
import { fetchBatteryLogsAction } from 'src/services/battery';

const initialState: {
  logs: Battery4chart[];
  isPending: boolean | null;
  hasError: boolean;
} = {
  logs: [],
  isPending: null,
  hasError: false,
};

const batteryLogsSlice = createSlice({
  name: 'batteryLogs',
  initialState,
  reducers: {
    clearBatteryState: (state) => {
      state.logs = [];
      state.isPending = null;
      state.hasError = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchBatteryLogsAction.pending, (state) => {
      state.hasError = false;
      state.isPending = true;
    });
    builder.addCase(fetchBatteryLogsAction.fulfilled, (state, { payload }) => {
      state.logs = payload.deviceBattery.map((log) => ({
        ...log,
        chargeCounter: Math.max(0, log.chargeCounter),
        dischargeSpeed: Math.max(0, log.dischargeSpeed),
        dischargeSpeedMah: Math.max(0, log.dischargeSpeedMah),
        isCharging: Number(log.isCharging),
      }));
      state.hasError = false;
      state.isPending = false;
    });
    builder.addCase(fetchBatteryLogsAction.rejected, (state) => {
      state.hasError = true;
      state.isPending = false;
    });
  },
});

export const { clearBatteryState } = batteryLogsSlice.actions;

const { reducer } = batteryLogsSlice;

export default reducer;
